<template>
  <div>
    <div class="panel" v-if="!itemTemplateId">
      <div class="filter">
        <el-form
          :inline="true"
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="90px"
          class="search-form"
          size="small"
        >
          <el-form-item label="编号">
            <el-input v-model="filter.code" placeholder="搜索编号"></el-input>
          </el-form-item>
          <el-form-item label="型号">
            <el-input
              v-model="filter.model_number"
              placeholder="搜索型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              v-model="filter.query"
              placeholder="搜索自定义属性值或备注"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <ItemStatusSelect
              v-model="filter.status"
              model="item"
              :clearable="true"
              blankLabel="全部（不含报废和灭失）"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="寿命预警">
            <ItemStatusSelect
              v-model="filter.lifewarning"
              model="lifewarning"
              :clearable="true"
              blankLabel="不限"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="组装基地">
            <BaseSelect
              v-model="filter.install_base_id"
              :clearable="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item :label="category == 1 ? '发往基地' : '库存基地'">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
          <el-form-item label="库存状态" v-if="category == 2">
            <el-select v-model="filter.stock_status">
              <el-option :key="0" :value="0" label="全部"></el-option>
              <el-option :key="1" :value="1" label="待入库"></el-option>
              <!-- <el-option :key="2" :value="2" label="待回收确认"></el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="待入库基地" v-if="category == 2">
            <BaseSelect
              v-model="filter.receive_base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="发往钻井" v-if="category == 2">
            <DrillWellSelect
              v-model="filter.drill_well_id"
              :clearable="true"
            ></DrillWellSelect>
          </el-form-item>
        </el-form>
        <div style="margin-left: 90px">
          <el-button type="primary" size="small" @click="productQuery()"
            >筛选</el-button
          >
          <el-button size="small" @click="productQuery(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel" v-if="waringList.length > 0 && !itemTemplateId">
      <el-link class="text-danger" :underline="false">寿命预警：</el-link>
      <el-link
        :underline="false"
        v-for="item in waringList"
        :key="item.template_id"
        class="mr-5"
        @click="productQuery(true, item.template_id)"
        >{{ item.template_name
        }}<span class="text-danger" style="margin-left: -5px"
          >（{{ item.count }}）</span
        ></el-link
      >
    </div>
    <div :class="{ panel: !itemTemplateId }" v-if="templates">
      <el-empty
        description="暂无数据，请先添加配件分类"
        v-if="templates.length == 0"
      ></el-empty>

      <template v-if="!itemTemplateId">
        <draggable
          :list="templates"
          ghost-class="ghost"
          @update="itemDragUpdate"
          :disabled="user.id != 1 && user.id != 27"
        >
          <el-tag
            class="mr-10 mb-10 pointer"
            :key="temp.id"
            :effect="temp.id == selectedTemp.id ? 'light' : 'plain'"
            :type="temp.id == selectedTemp.id ? 'primary' : 'info'"
            @click="getProductData(temp, 1)"
            v-for="temp in templates"
            >{{ temp.name
            }}<span class="cus-badge" v-if="temp.stocking_count">{{
              temp.stocking_count
            }}</span>
          </el-tag>
        </draggable>
      </template>
      <ItemTable
        :template="selectedTemp"
        v-if="selectedTemp"
        :filter="filter"
        ref="itemTable"
        @baseCheck="handleBaseCheck"
      ></ItemTable>
    </div>
  </div>
</template>

<script>
import { itemTemplateList, itemTemplateSort, itemList } from '@/service/getData'
import ItemTable from './table'
import draggable from 'vuedraggable'
import store from '@/store/index'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
    itemTemplateId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ItemTable,
    draggable,
  },
  data() {
    return {
      activeTab: 'tab0',
      selectedTemp: null,
      templates: null,
      waringList: [],
      filter: {
        category: this.category,
        code: '',
        query: '',
        lifewarning: 0,
        model_number: '',
        base_id: 0,
        status: 0,
        stock_status: 0,
        drill_well_id: 0,
        receive_base_id: 0,
        install_base_id: 0,
        item_template_id: 0,
        page: 1,
        size: 10,
      },
      user: store.state.userInfo,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    handleBaseCheck() {
      if (this.itemTemplateId == 0 && this.category == 2) {
        let currentTemp = this.templates.find(
          (temp) => temp.id === this.selectedTemp.id,
        )
        let index = this.templates.indexOf(currentTemp)
        this.templates[index].stocking_count--
      }
    },
    async getWaringData() {
      if (this.itemTemplateId) {
        return
      }
      let res = await itemList({
        category: this.category,
        warning_statistic: true,
      })
      if (res.code == 0) {
        this.waringList = res.data.list
      }
    },
    async getData() {
      let res = await itemTemplateList({
        page: 0,
        size: 1000,
        category: this.category,
        id: this.itemTemplateId,
        order_sort: true,
        stocking_count: this.itemTemplateId == 0 && this.category == 2,
      })
      this.templates = res.data.list
      if (this.templates.length > 0) {
        let selectedTemp = this.filter.item_template_id
          ? this.templates.filter(
              (item) => item.id == this.filter.item_template_id,
            )[0]
          : this.templates[0]
        this.getProductData(selectedTemp, this.filter.page || 1)
        this.getWaringData()
      }
    },
    getProductData(temp, page = 1) {
      this.selectedTemp = temp
      this.filter.item_template_id = temp.id
      this.filter.page = page

      let _this = this
      this.$nextTick(() => {
        _this.$refs.itemTable.getData()
      })
    },
    productQuery(reset = false, templateId = 0) {
      if (reset) {
        this.filter.code = ''
        this.filter.query = ''
        this.filter.model_number = ''
        this.filter.lifewarning = 0
        this.filter.base_id = 0
        this.filter.status = 0
        this.filter.stock_status = 0
        this.filter.drill_well_id = 0
        this.filter.receive_base_id = 0
        this.filter.install_base_id = 0
      }

      if (templateId) {
        //筛选某个分类的预警
        this.selectedTemp = this.templates.find((item) => item.id == templateId)
        this.filter.item_template_id = templateId
        this.filter.lifewarning = 1
      }

      this.filter.page = 1
      if (this.filter.receive_base_id) {
        this.filter.stock_status = 1
      }

      this.$refs.itemTable.getData()
    },
    async itemDragUpdate() {
      var ids = this.templates.map((item) => {
        return item.id
      })

      let res = await itemTemplateSort({
        ids: ids,
      })
    },
  },
}
</script>

<style scoped>
.pointer {
  position: relative;
}
.cus-badge {
  position: absolute;
  right: -6px;
  top: -8px;
  background-color: rgb(245, 108, 108);
  color: rgb(255, 255, 255);
  display: inline-block;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  border-radius: 8px;
  padding: 0px 4px;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(255, 255, 255);
  border-image: initial;
}
</style>